/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import CountrySelectInput from "../shared/countrySelectInput";
import { addDoc, collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import { getDirectories } from "../../lib/directory";
import { TiDelete } from "react-icons/ti";
import { useSlowScroll } from "../../hooks/useSlowScroll";
const LoadAddress = ({
  formData,
  handleChange,
  setFormData,
  invalidLoadAddressFields,
  setInvalidLoadAddressFields,
}) => {
  // console.log(formData)
  const [loading, setLoading] = useState(false);
  const [selectedDirectory, setSelectedDirectory] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredDirectories, setFilteredDirectories] = useState([]);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleInputChange = (e) => {
    e.stopPropagation();
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handlePickUpTime = (field, e) => {
    const { value } = e.target;

    // Update the formData based on the field (startTime or endTime)
    setFormData((prevData) => {
      const updated = {
        ...prevData,
        loadAddress_PickUpTime: {
          ...prevData.loadAddress_PickUpTime,
          [field]: value,
        },
      };
      // If both times are set, clear the group error highlight
      const st = updated.loadAddress_PickUpTime?.startTime;
      const et = updated.loadAddress_PickUpTime?.endTime;
      if (st && et && setInvalidLoadAddressFields) {
        setInvalidLoadAddressFields((prev) =>
          prev.filter((k) => k !== "loadAddress_PickUpTime")
        );
      }
      return updated;
    });
  };

  // console.log('d', formData.loadAddress_PickUpTime)

  // console.log('dhhdhd', formData);
  const { data, isLoading, isError, refetch } = useQuery(
    ["dictories"], // Change the key to match the getUsers function
    async () => {
      const res = await getDirectories();
      return res;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (searchTerm.trim() !== "") {
      setFilteredDirectories(
        data.filter((directory) =>
          Object.values(directory).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(searchTerm.toLowerCase())
          )
        )
      );
    } else {
      setFilteredDirectories(data);
    }
  }, [data, searchTerm]);

  const handleDirectory = (Id) => {
    const Directory = data.find((directory) => directory.id === Id);
    setSelectedDirectory(Directory);
    setIsOpen(false);
  };
  useEffect(() => {
    function handleClickOutside(event) {
      const dropdownElement = document.querySelector(".load-directory");
      if (dropdownElement && !dropdownElement.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selectedDirectory) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        loadAddress_CompanyName: selectedDirectory.companyName || "",
        loadPostalCode: selectedDirectory.postalCode || "",
        loadCountry: selectedDirectory.country || "",
        loadAddress_HouseNo: selectedDirectory.houseNo || "",
        loadAddress: selectedDirectory.address || "",
      }));
    }
  }, [selectedDirectory, setFormData]);

  const handleAddData = async (e) => {
    e.preventDefault(); // Prevent form submission from reloading the page
    // console.log(formData);
    try {
      setLoading(true);
      const directoryData = {
        companyName: formData.loadAddress_CompanyName || "",
        country: formData.loadCountry || "",
        postalCode: formData.loadAddressPostalCode || "",
        houseNo: formData.loadAddress_HouseNo || "", // Changed to 'loadAddress_HouseNo'
        address: formData.loadAddress || "",
        loadAddress: true,
      };
      // console.log("directory", directoryData);
      const directoryCollection = collection(db, "directory"); // Changed to 'directory' collection
      await addDoc(directoryCollection, directoryData);
      refetch();
      toast.success("Address saved in Directory successfully!");
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteDirectory = async (id) => {
    if (!id) return;
    try {
      const userRef = doc(db, "directory", id);
      await deleteDoc(userRef);

      toast.success("Directory Removed successfully");
      refetch();
    } catch (error) {
      console.error("Error deleting quotes", error);
      if (error.code === "not-found") {
        // Handle case when the document is not found
        toast.warning("User not found");
      } else {
        // Handle other errors
        toast.error(`Could not delete quotes: ${error.message}`);
      }
    }
  };

  // console.log(formData)
  const handleStartTimeWheel = useSlowScroll((e) => handlePickUpTime("startTime", e));
  const handleEndTimeWheel = useSlowScroll((e) => handlePickUpTime("endTime", e));

  // Confirm before changing Load Country
  const [showLoadCountryConfirm, setShowLoadCountryConfirm] = useState(false);
  const [pendingLoadCountry, setPendingLoadCountry] = useState("");

  const handleLoadCountryChange = (e) => {
    const next = e.target.value;
    const prev = formData.loadCountry || "";
    if (prev && next !== prev) {
      setPendingLoadCountry(next);
      setShowLoadCountryConfirm(true);
      return;
    }
    handleChange(e);
  };
  return (
    <div>
      {/* first inputs */}

      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <div className="flex flex-col gap-1 py-2 w-full">
          <label className="w-full text-sm font-normal" htmlFor="dropdown-button">
            Directory
          </label>
          <div className="relative group w-full load-directory">
            <button
              id="dropdown-button"
              onClick={toggleDropdown}
              className="inline-flex  justify-between w-full px-4 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500 "
            >
              <span className="mr-2">Select Directory</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 ml-2 -mr-1"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <div
              id="dropdown-menu"
              className={`w-full absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 max-h-[40vh] overflow-y-auto ring-black ring-opacity-5 p-1 space-y-1 ${
                isOpen ? "" : "hidden"
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <input
                id="search-input"
                className="block w-full px-4 py-2 text-gray-800 border rounded-md  border-gray-300 focus:outline-none"
                type="text"
                placeholder="Search directories"
                autoComplete="off"
                value={searchTerm}
                onChange={handleInputChange}
              />
              {filteredDirectories &&
                filteredDirectories.map((directory) => (
                  <div
                    key={directory.id}
                    className="flex items-center justify-between px-4 py-2 cursor-pointer hover:bg-gray-100 "
                    onClick={() => handleDirectory(directory.id)}
                  >
                    <div>
                      {directory?.companyName} , {directory?.country}{" "}
                    </div>
                    <TiDelete
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteDirectory(directory.id);
                      }}
                      className="text-red-500 text-2xl"
                    />
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="loadAddress_ReferenceCustomer">
            Reference Customer <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder=""
            className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
              invalidLoadAddressFields.includes("loadAddress_ReferenceCustomer")
                ? "border-red-500"
                : ""
            }`}
            id="loadAddress_ReferenceCustomer"
            name="loadAddress_ReferenceCustomer"
            onChange={handleChange}
            value={formData?.loadAddress_ReferenceCustomer}
          />
        </div>
        <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="loadAddress_CompanyName">
            Company Name
          </label>
          <input
            type="text"
            placeholder=""
            className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
              invalidLoadAddressFields.includes("loadAddress_CompanyName")
                ? "border-red-500"
                : ""
            }`}
            id="loadAddress_CompanyName"
            name="loadAddress_CompanyName"
            onChange={handleChange}
            value={formData?.loadAddress_CompanyName}
          />
        </div>
      </div>
      {/* first inputs */}

      {/* Second inputs */}
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <div className="flex flex-col gap-1 py-2 country">
          <CountrySelectInput
            label="Country"
            onChange={handleLoadCountryChange}
            value={formData.loadCountry}
            name="loadCountry"
            id="loadCountry"
          />
        </div>
        <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="loadAddress_ContactName">
            Contact Name 
          </label>
          <input
            type="text"
            placeholder=""
            className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
              invalidLoadAddressFields.includes("loadAddress_ContactName")
                ? "border-red-500"
                : ""
            }`}
            id="loadAddress_ContactName"
            name="loadAddress_ContactName"
            onChange={handleChange}
            value={formData?.loadAddress_ContactName}
          />
        </div>

        <div className="flex flex-wrap gap-4">
          <div className="flex flex-col  w-full gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="loadPostalCode">
              Postal Code <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder=""
              className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
                invalidLoadAddressFields.includes("loadPostalCode")
                  ? "border-red-500"
                  : ""
              }`}
              id="loadPostalCode"
              name="loadPostalCode"
              onChange={handleChange}
              value={formData?.loadPostalCode}
            />
          </div>
          {/* <div className="flex flex-col w-full gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="name">
              House No.
            </label>
            <input
              type="text"
              placeholder=""
              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
              id="loadAddress_HouseNo"
              name="loadAddress_HouseNo"
              onChange={handleChange}
              value={formData?.loadAddress_HouseNo}
            />
          </div> */}
        </div>
      </div>
      {/* Second inputs */}

      {/* Three inputs */}
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <div className="flex flex-col gap-1  lg:flex-row lg:flex-wrap">
          <div className="flex flex-col w-full gap-1 py-2">
            <label className="w-full text-sm font-normal" htmlFor="loadAddress_PickUpDate">
              Pick Up date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              placeholder=""
              className={`h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
                invalidLoadAddressFields.includes("loadAddress_PickUpDate")
                  ? "border-red-500"
                  : ""
              }`}
              id="loadAddress_PickUpDate"
              name="loadAddress_PickUpDate"
              onChange={handleChange}
              value={formData?.loadAddress_PickUpDate}
              style={{ width: "100%" }}
            />
          </div>
          <div className="flex flex-col w-full gap-1 py-2 mt-4 ">
            <label className="w-full text-sm font-normal" htmlFor="loadStartTime">
              Pick up Time <span className="text-red-500">*</span>
            </label>
            <div className="flex gap-2 items-center">
              Between
              <input
                type="time"
                placeholder=""
                className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
                  invalidLoadAddressFields.includes("loadAddress_PickUpTime") &&
                  !formData.loadAddress_PickUpTime?.startTime
                    ? "border-red-500"
                    : ""
                }`}
                id="loadStartTime"
                name="startTime"
                onChange={(e) => handlePickUpTime("startTime", e)} 
                onWheel={handleStartTimeWheel}
                value={formData.loadAddress_PickUpTime?.startTime || ""} 
              />{" "}
              to
              <input
                type="time"
                placeholder=""
                className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
                  invalidLoadAddressFields.includes("loadAddress_PickUpTime") &&
                  !formData.loadAddress_PickUpTime?.endTime
                    ? "border-red-500"
                    : ""
                }`}
                id="loadEndTime"
                name="endTime"
                onChange={(e) => handlePickUpTime("endTime", e)} 
                onWheel={handleEndTimeWheel}
                value={formData.loadAddress_PickUpTime?.endTime || ""} 
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="loadAddress_PhoneNumber">
            Phone Number
          </label>
          <input
            type="number"
            placeholder=""
            className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue`}
            id="loadAddress_PhoneNumber"
            name="loadAddress_PhoneNumber"
            onChange={handleChange}
            value={formData?.loadAddress_PhoneNumber}
            pattern="(\+)?[\d\s-]{0,20}"
            minLength="0"
            maxLength="20"
          />
        </div>

        <div className="flex flex-col gap-1 py-2">
          <label className="w-full text-sm font-normal" htmlFor="loadAddress">
            Address <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder=""
            className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
              invalidLoadAddressFields.includes("loadAddress")
                ? "border-red-500"
                : ""
            }`}
            id="loadAddress"
            name="loadAddress"
            onChange={handleChange}
            value={formData?.loadAddress}
          />
        </div>
      </div>
      <button
        className=" text-sm px-2 py-1 h-10 text-[#fff] rounded-lg  w-28"
        style={{ background: "#053f92" }}
        onClick={handleAddData}
      >
        {loading ? "Loading..." : "Directory +"}
      </button>
      <div className="flex flex-col gap-1 py-2">
        <label>Comments</label>

        <textarea
          className="border border-[#B3C5DF] h-[100px] rounded-lg  focus:outline-none p-2 "
          style={{ fontSize: '14px' }}
          id="comments"
          name="loadAddress_Comments"
          onChange={handleChange}
          value={formData?.loadAddress_Comments}
          maxLength={500}
        />
      </div>
      {/* Confirmation modal for Load Country change */}
      <Modal
        title="Confirm Country Change"
        open={showLoadCountryConfirm}
        onOk={() => {
          handleChange({ target: { name: "loadCountry", value: pendingLoadCountry } });
          setShowLoadCountryConfirm(false);
        }}
        onCancel={() => setShowLoadCountryConfirm(false)}
        okText="Yes, change"
        cancelText="No"
      >
        <p>Are you sure you want to change the Load Country?</p>
      </Modal>
    </div>
  );
};

export default LoadAddress;
